/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { ModalOverlay as ChakraModalOverlay, ModalOverlayProps } from '@chakra-ui/react'
import React from 'react'

import * as styles from './styles'

interface Props extends ModalOverlayProps {}

export const ModalOverlay = ({ css, ...rest }: Props) => {
  return <ChakraModalOverlay css={[styles.overlay, css]} {...rest} />
}
